export default "__VITE_ASSET__$FtZr8n9__"